import { render, staticRenderFns } from "./WatchListDialog.vue?vue&type=template&id=400ab54b"
import script from "./WatchListDialog.vue?vue&type=script&lang=js"
export * from "./WatchListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports